import React from 'react';

import copyIcon from '../../../../icons/copy.svg';

import classes from './CopyButton.css';


const copyButton = props => {
    return (
        <div className={classes.ButtonGroupWrapper}>
            <div className={classes.CopyNameButtonGroup}>
                <div className={classes.NameCopyHelper}
                    onClick={props.copyNamesClicked}>
                    <img 
                        className={classes.Image}
                        src={copyIcon}
                        alt="not found" />
                    <p>Name</p>
                </div>
            </div>
            <div className={classes.CopyPaypalButtonGroup}>
                <div className={classes.PaypalCopyHelper}
                    onClick={props.paypalClicked}>
                    <img 
                        className={classes.Image}
                        src={copyIcon}
                        alt="not found" />
                    <p>PayPal</p>
                </div>
            </div>
            <div className={classes.CopyOtherButtonGroup}>
                <div className={classes.OtherCopyHelper}
                    onClick={props.otherClicked}>
                    <img 
                        className={classes.Image}
                        src={copyIcon}
                        alt="not found" />
                    <p>E-List</p>
                </div>
            </div>
        </div>
    )
}

export default copyButton


// WEBPACK FOOTER //
// ./src/components/UI/Buttons/CopyButton/CopyButton.js